<template>
  <v-flex
     xs12
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs6 class="mr-2">
        <AutoComplete
        :value="searchTeacher"
        v-model="searchTeacher"

        key-value="id"
        key-name="fulltext"
        enable-chips
        enable-clearable
        enable-autofocus
        :items="teachers"
        :label="$t('fields.teacher')"
        @search="searchTeachers"
        @input="fetchTeacherIfExist"
        @clear="deleteSelectedTeacher"
        :delay="900"
        :errors="errors"
      >
      </AutoComplete>

      </v-flex>

      <v-flex xs3 class="mr-2">
      <v-select
        :items="years"
        multiple
        v-model="filters.years"
        attach
        chips
        :label="$t('fields.years')"
      >
      </v-select>
      </v-flex>
      <v-flex xs2 class="mt-3">
      <v-btn
        v-if="can('create teachers') && currentUser.user.is_propagandist"
        @click="showCampaignModal(0)"
        color="primary"
        block
      >{{ $t("NEW_ESSAY") }}
      </v-btn>
      </v-flex>
    </v-row>
    <v-row>
      <v-flex xs2 class="mr-2 mt-2">
        <Search
          v-model="filters.isbn"
          :label="$t('SEARCH_BOOK_ISBN')"
          :delay="500"
        />
      </v-flex>
    </v-row>
    </v-container>
    <v-row>
      <v-col
        cols="12"
      >
        <TeacherCommonInfo v-if="Object.keys(teacher).length" :teacher="teacher"/>
      </v-col>
    </v-row>
    <v-row v-if="otherPropagandistBooks.length">
      <v-col cols="12">
        <v-card class="mb-2">
          <v-card-title class="subtitle-1">
            {{ $t('ASSIGNED_BOOKS_OTHER_PROPAGANDISTS') }}
          </v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">{{ $t('fields.isbn') }}</th>
                    <th class="text-left">{{ $t('fields.title') }}</th>
                    <th class="text-left">{{ $t('fields.volume') }}</th>
                    <th class="text-left">{{ $t('fields.propagandist') }}</th>
                    <th class="text-left">{{ $t('fields.date') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(assignedBook, index) in otherPropagandistBooks"
                    :key="index"
                  >
                    <td>{{ assignedBook.isbn }}</td>
                    <td>{{ assignedBook.title }}</td>
                    <td>{{ assignedBook.volume }}</td>
                    <td>{{ assignedBook.propagandist_name }}</td>
                    <td>{{ formatAssignedAt(assignedBook.assigned_at) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
    <v-col
      cols="12"
    >
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >


    <template v-slot:[`item.teachers.surname`]="{ item }">
            {{ item.teacher.fullname }}
      </template>

      <template v-slot:[`item.title`]="{ item }">
            {{ item.book.title }}
      </template>

      <template v-slot:[`item.isbn`]="{ item }">
            {{ item.book.isbn }}
      </template>

      <template v-slot:[`item.volume`]="{ item }">
            {{ item.book.volume }}
      </template>

      <template v-slot:[`item.book_type`]="{ item }">
            {{ item.book.book_type }}
      </template>

      <template v-slot:[`item.editor`]="{ item }">
            {{ item.editor.name }}
      </template>

      <template v-slot:[`item.shipping_type`]="{ item }">
          {{ $t(`delivery_methods.${item.campaign_book.shipping_type}`) }}
          <span v-if="isShippedToSchool(item.campaign_book.shipping_type)">
            - ({{ getBranchCode(item) }})
          </span>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        {{ $t(`campaign_statuses.${getLastStatus(item.campaign_book.statuses).status}`) }}
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
            {{ item.campaign_book.created_at | timeFormat }}
      </template>

      <template v-slot:[`item.updated_at`]="{ item }">
            {{ getLastStatus(item.campaign_book.statuses).updated_at | timeFormat }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
           <v-layout wrap>
              <v-flex>
                <v-tooltip
                  v-if="can('create teachers') || can('edit teachers') || can('delete teachers')"
                  bottom
                  :disabled="isDeletable(item.campaign_book.statuses)"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <!-- span: un v-btn disattivato non riceve gli eventi del tooltip -->
                    <span v-bind="attrs" v-on="on">
                      <v-btn
                        icon
                        color="red"
                        :disabled="!isDeletable(item.campaign_book.statuses)"
                        @click="deleteBookTeacher(item.campaign_book.id)"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ notDeletableReason(item.campaign_book.statuses) }}</span>
                </v-tooltip>
              </v-flex>
           </v-layout>
      </template>

    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchCampaigns"
    />
    </v-col>
    </v-row>
  </div>
  </v-flex>
</template>
<script>

  import { mapActions, mapGetters } from 'vuex';

  import { campaignsService } from '../../utils/services/campaigns.service';
  import { teachersService } from '../../utils/services/teachers.service';
  import AutoComplete from '../../components/shared/Inputs/AutoComplete';
  import CampaignTeacherModal from '../../components/modals/Campaigns/CampaignTeacherModal';
  import TeacherCommonInfo from '../../components/app/Teachers/TeacherCommonInfo.vue';
  import { DeliveryMethods } from '../../utils/constants/delivery-methods';
  import Search from '../../components/shared/Inputs/Search';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'CampaignTeacher',
    components: { AutoComplete, TeacherCommonInfo, Search, Paginator },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        searchTeacher: null,
        teacher: {},
        teachers: [],
        teacherAssignedBooks: [],
        years: [],
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [true],
          sortBy: ['created_at'],
        },

        headers: [
          { text: this.$t('fields.teacher'), value: 'teachers.surname' },
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume' },
          { text: this.$t('fields.editor'), value: 'editor' },

          { text: this.$t('fields.type_shipping'), value: 'shipping_type' },
          { text: this.$t('fields.book_type'), value: 'book_type' },

          { text: this.$t('fields.created_at'), value: 'created_at' },
          { text: this.$t('fields.status'), value: 'status', sortable: false },
          { text: this.$t('fields.updated_at'), value: 'updated_at' },

          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        filters: {
          searchTeacher: null,
          teacherId: null,
          years: null,
          isbn: null,
        },
      };
    },
    computed: {
      ...mapGetters('user', ['currentUser']),
      requestFilters() {
        const filters = {
          teacher_id: this.filters.teacherId,
          years: this.filters.years,
          isbn: this.filters.isbn,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

      otherPropagandistBooks() {
        if (!this.currentUser || !this.currentUser.user) {
          return [];
        }
        const currentId = Number(this.currentUser.user.id);
        return this.teacherAssignedBooks.filter(book => Number(book.propagandist_id) !== currentId);
      },

    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      getBranchCode(item) {
        return item && item.schools && item.schools.location_options
          ? item.schools.location_options.branch_code
          : '';
      },
      initYears() {
        this.years = [];
        const year = new Date().getFullYear();
        for (let i = 0; i <= 5; i += 1) {
          this.years.push(year - i);
        }
      },

      isShippedToSchool(shippingType) {
        return DeliveryMethods.SCHOOL === shippingType;
      },

      setAssignedBoonInfoToLocalStorage(data) {
        localStorage.setItem('campaign-last-books', JSON.stringify(data));
      },

      getAssignedBoonInfoToLocalStorage() {
        return JSON.parse(localStorage.getItem('campaign-last-books'));
      },

      async showCampaignModal(id) {
        this.showModal({
          component: CampaignTeacherModal,
            data: {
              stored: {
                id,
                teacher_id: this.filters.teacherId,
              },
          },
          options: {
            title: this.$t('CAMPAIGN'),
            fullscreen: true,
            onSave: (
              form,
              error,
            ) => campaignsService.save(form)
            .then(() => {
              this.setAssignedBoonInfoToLocalStorage(form.assigned);
              this.hideModal({});
              this.fetchCampaigns(1);
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.hideModal({});
            }),
          },
        });
      },

      async deleteBookTeacher(id) {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return campaignsService.removeReservation({ ids: [id] })
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchCampaigns(1);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },

      searchTeachers(val) {
        this.filters.searchTeacher = val;
        this.fetchTeachers();
      },

      async fetchTeachers() {
        this.loading = true;
        return teachersService.index({
          filters: {
            search: this.filters.searchTeacher,
            sortBy: ['surname', 'name'],
            sortDesc: [false, false],
          },
          itemsPerPage: 100,
        })
        .then(response => {
          this.teachers = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchCampaigns(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return campaignsService.teacherIndex({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async fetchTeacherIfExist(id) {
        if (id > 0) {
          this.filters.teacherId = id;
          await this.fetchTeacher(id);
          await this.fetchTeacherAssignedBooks(id);
        } else {
          this.filters.teacherId = 0;
        }
      },

      fetchTeacherAssignedBooks(teacherId) {
        return campaignsService.checkTeacherBooks({ teacher_id: teacherId })
          .then(response => {
            this.teacherAssignedBooks = response.data;
          })
          .catch(() => {
            this.teacherAssignedBooks = [];
          });
      },

      formatAssignedAt(value) {
        // Data grezza dal DB, in UTC
        return this.$options.filters.utcTime(value, 'DD/MM/YYYY');
      },

      fetchTeacher(id) {
        this.loading = true;
        return teachersService.get(id)
        .then(response => {
            this.teacher = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      prepareTeacherInfo() {
        let teacherInfo = [];
        if (Object.keys(this.teacher).length) {
          const address = this.teacher.addresses.filter(x => x.options && x.options.is_default)[0];

          teacherInfo = [
            { value: this.teacher.surname },
            { value: this.teacher.name },
            { value: address.email },
            { value: address.phone },
            { value: address.street },
          ];
        }
        return teacherInfo;
      },

      prepareInfoSchool(school) {
        return [
          { value: school.school_name },
          { value: school.subject_name },
          { value: school.school_code },
        ];
      },

      deleteSelectedTeacher() {
        this.teacher = {};
        this.teacherAssignedBooks = [];
      },

      getLastStatus(items) {
        return items[items.length - 1];
      },

      // Il backend permette la cancellazione solo di libri assegnati o prenotati
      isDeletable(statuses) {
        const last = this.getLastStatus(statuses);
        return !!last && ['ASSIGNED', 'STATUS_BOOKED'].includes(last.status);
      },

      notDeletableReason(statuses) {
        const last = this.getLastStatus(statuses);
        if (!last) {
          return '';
        }
        return this.$t('campaign_book_not_deletable', {
          status: this.$t(`campaign_statuses.${last.status}`),
        });
      },

    },
    async created() {
      console.log(this.getAssignedBoonInfoToLocalStorage);
      this.initYears();
      if (parseInt(this.$route.query.id, 10)) {
        await this.fetchTeacherIfExist(this.$route.query.id);
      }

      await this.fetchCampaigns(1);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchCampaigns(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchCampaigns(1);
          }
        },
      },
    },
  };
</script>
